import { Column } from "components/grid/column";
import React from "react";
import { Heading, Text } from "spectacle";

export const S50 = () => (
  <>
    <Column paddingBottom={48}>
      <Text textColor="secondary">How to handle the</Text>
    </Column>

    <Heading caps size={1}>
      transition
    </Heading>
  </>
);
